import { useAuth } from '@/auth/useAuth';

/**
 * Used only when no signed-in user is available (a signed-out render or a test double without
 * the workspace fields). Every real session carries its workspace's own currency.
 */
const FALLBACK_CURRENCY = 'USD';

/**
 * The ISO 4217 code every amount in the signed-in workspace is denominated in.
 *
 * @returns the workspace currency
 */
export function useWorkspaceCurrency(): string {
  const { user } = useAuth();
  const currency = user?.workspaceCurrency;
  return currency !== undefined && currency !== '' ? currency : FALLBACK_CURRENCY;
}

/**
 * The IANA zone the signed-in workspace keeps its calendar in.
 *
 * @returns the workspace time zone, or the browser's own zone when the session does not carry one
 */
export function useWorkspaceTimeZone(): string {
  const { user } = useAuth();
  const zone = user?.workspaceTimeZone;
  return zone !== undefined && zone !== ''
    ? zone
    : Intl.DateTimeFormat().resolvedOptions().timeZone;
}
